import { render, staticRenderFns } from "./EditServiceSpendLimitDialog.vue?vue&type=template&id=71800aa0&"
import script from "./EditServiceSpendLimitDialog.vue?vue&type=script&lang=js&"
export * from "./EditServiceSpendLimitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports